import React from 'react';

function Separator() {
  return <hr className="my-8 border-gray-200" />;
}

export default Separator;